export default "__VITE_ASSET__DVDBD8OA__"